import React, { useState } from "react";
import SingleCounter from "../components/Counter/singlecounter";
import ProgressBar from "../components/ProgressBar/progressBar";
import SpeedoMeterPreview from "../components/SpeedoMeter/speedometer";
import Shimmer from "../components/Shimmer/shimmer";
import useWidgetData from "../hooks/useWidgetData";
import BannerPreview from "../components/Banner/banner";
import Popover from "../components/ReusableComponents/Popover";
import ListInterface from "../components/ListInterface";
import analytics from "../utils/analytics";
import { getList, handleWidgetClick, isListInterfaceAllowed } from "./helper";
import { widgetTypes } from "../utils/constants";
import "./widget.css";

const Widget = ({ widget, smartviewsConfig, activeDashboardId, forceRefresh }) => {
  const { id, widgetType: type, config } = widget;

  const [list, setList] = useState([]);
  const [isError, setIsError] = useState(null);
  const [isListLoading, setIsListLoading] = useState(true);

  const { widgetData, loading } = useWidgetData(
    widget,
    smartviewsConfig,
    activeDashboardId,
    forceRefresh
  );

  const count = widgetData?.count;

  const widgetMap = {
    progressbar: <ProgressBar configData={{ config: widgetData }} />,
    singlecounter: <SingleCounter configData={{ config: widgetData }} />,
    speedometer: <SpeedoMeterPreview configData={{ config: widgetData }} />,
    banner: <BannerPreview configData={{ config: widgetData }} />,
  };

  const handleOpenList = async () => {
    try {
      setIsListLoading(true);
      const list = await getList(config, smartviewsConfig);
      setList(list);
    } catch (error) {
      setIsError(error);
    } finally {
      setIsListLoading(false);
    }

    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent(`${type} widget clicked`, analyticsData);
  }

  const handleCloseList = () => {
    setList([]);
    setIsError(null);
  }

  const content = widgetMap[type] || (
    <div role="unknown-widget">Unknown Widget Type</div>
  );

  const showListInterface = isListInterfaceAllowed(type, config, smartviewsConfig, count);



  /*===========================================
  *************** RETURNING UI ****************
  ============================================*/

  if (loading)
    return (
      <div className="widget-container">
        <Shimmer width="100%" height="100%" />
      </div>
    )

  else if (showListInterface)
    return (
      <div className="widget-container">
        <div className="widget-content" role="widget-content">
          <Popover trigger={content} onOpen={handleOpenList} onClose={handleCloseList}>
            <ListInterface data={{ config, smartviewsConfig, id, type, list, isListLoading, isError, count, retryHandler: handleOpenList }} />
          </Popover>
        </div>
      </div>
    )

  else if ((type === widgetTypes.SingleCounter && !showListInterface) || !count)
    return (
      <div className="widget-container">
        <div className="widget-content" role="widget-content" onClick={() => handleWidgetClick(config, id)}>
          {content}
        </div>
      </div>
    )

  return (
    <div className="widget-container">
      {content}
    </div>
  )
};

export default Widget;
